module.exports = __webpack_public_path__ + "img/inactive-4.54c7a1db.svg";